// @ts-nocheck
import { catchAndNotify } from '@/src/handlers';
import { getWidgets, getTenantId, getPortalSettings } from './api';
import {
  fromServerWidgetsToInternalFormat,
  indexPlatformWidgets,
  remapWidgetStoreResponse,
  generateFlatNavGraph
} from './converters';
import { widgetsDomain, domainKey } from './constants';

const traceId = '14720a81-ddaa-45f7-a095-9ca12164c909';

export const getTenantIdFx = widgetsDomain.createEffect({
  name: `${domainKey}/effects/getTenantIdFx`,
  handler: async (params: 'public' | 'private') => {
    const sessionSavedTenentId = sessionStorage.getItem('tenentId');
    if (!sessionSavedTenentId) {
      const { tenentId } = await getTenantId();
      sessionStorage.setItem('tenentId', tenentId);
      return tenentId;
    }
    return sessionSavedTenentId as string;
  }
});

getTenantIdFx.fail.watch(() =>
  catchAndNotify({ message: 'Failed to get tenant ID', traceId: `${traceId}--4` })
);

interface GetWidgetsFxPayload {
  type: 'public' | 'private';
  tenantId: string;
  overrides: Record<number, IWidgetMetadata>;
}

export const getWidgetsFx = widgetsDomain.createEffect({
  name: `${domainKey}/effects/getWidgetsFx`,
  handler: async (payload: GetWidgetsFxPayload) => {
    const { type, tenantId, overrides } = payload;
    const data = await getWidgets(type, tenantId);
    const remapped = data.reduce(remapWidgetStoreResponse(overrides), {
      platform: [],
      dashboard: []
    });
    return {
      dashboard: fromServerWidgetsToInternalFormat(remapped.dashboard),
      platform: indexPlatformWidgets(remapped.platform)
    };
  },
  sid: `${domainKey}/effects/getWidgetsFx`
});

getWidgetsFx.fail.watch(({ error }) => {
  const { status } = JSON.parse(error.message || '{}');

  if (status === 401) {
    return;
  }
  catchAndNotify({ message: error.toString(), traceId: `${traceId}--2` });
});

export const getPortalSettingsFx = widgetsDomain.createEffect({
  name: `${domainKey}/effects/getPortalSettingsFx`,
  async handler() {
    const portalConfig = await getPortalSettings();

    // TODO: drop me after migrate CORE_RelatedParties
    window.NAVGRAPH = portalConfig.navgraph;

    return {
      ...portalConfig,
      flatNavGraph: generateFlatNavGraph(portalConfig.navgraph)
    };
  },
  sid: `${domainKey}/effects/getPortalSettingsFx`
});

getPortalSettingsFx.fail.watch(() =>
  catchAndNotify({ message: 'Failed to get portal settings', traceId: `${traceId}--5` })
);
